/**
 * True when the given pathname is the photobook entry quiz
 * (`/{locale}/photobook/{launch}`) or the bio form that follows a book
 * order (`/{locale}/photobook/bio/{token}`).
 *
 * Used to suppress the global promo banner and the sticky footer ad: the
 * quiz is the thing the banner is advertising, so leaving it up would put a
 * competing call to action above a funnel the visitor is already inside.
 */
export default function isPhotobookPath(pathname) {
  // Same shapes as the routes in RouteWrapper, so a mistyped or partial link
  // (/us/photobook, /us/photobook/x/y) keeps the normal header and ads.
  return /^\/[^/]+\/photobook\/(bio\/)?[^/]+\/?$/.test(pathname || '');
}
